export default "__VITE_ASSET__BGNbzCy$__"